export default {
  ms: 480,
  sm: 800,
  md: 1024,
  ml: 1200,
  lg: 1280,
  xl: 1600,
};
